import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SPEEDING_OPTIONS } from "../../constants";
import { AdminFormFieldDropdown } from "../../../../components/admin/formFields";

interface SpeedingProps {
  values: any;
  errors: any;
  touched: any;
  handleChange: (event: React.ChangeEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
  handleBlur: (event: React.FocusEvent<any>) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
  selectedField: string;
}

const Speeding: FC<SpeedingProps> = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  selectedField,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management.traffic_signal_detection",
  });

  const eventKey = "mmfOverSpeed_audioAlert";

  return (
    <>
      <div className="col-span-6 p-6 border-b space-y-1">
        <div className="w-full space-y-2 mb-4">
          <h1 className="text-lg text-accent-blue-dark font-bold mb-4">
            {t("speedingEnable")}
          </h1>
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("mode")}
          </h2>
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("general_mode")}
          </h2>
          <p className="font-normal text-sm leading-none mb-4 text-gray-500">
            {t("speeding_desc")}
          </p>
        </div>
        <AdminFormFieldDropdown
          label={t("in_cabin_audio_alert")}
          id={eventKey}
          name={eventKey}
          value={values[eventKey] || "minor"}
          key={eventKey}
          options={SPEEDING_OPTIONS}
          onChange={(e) => {
            setFieldValue(eventKey, e?.value);
          }}
          onBlur={(e) => {
            setFieldTouched(eventKey, true);
            handleBlur(e);
          }}
          error={errors[eventKey]}
          touched={touched[eventKey]}
          customWrapperClass="col-span-3"
        />
      </div>
    </>
  );
};

export default Speeding;
